import { baseAPI } from '~shared/api/base-api';

export interface ReportingTrialClassReportParams {
  startDate: string;
  endDate: string;
  format?: string;
}

export const reportingTrialClassReportAPI = async ({
  format = 'csv',
  ...params
}: ReportingTrialClassReportParams) => {
  const response = await baseAPI.get<string>('reporting/trial-class-report', {
    params: {
      ...params,
      format,
    },
    responseType: 'text',
  });
  return response.data;
};
